import { Link } from "react-router-dom";
import { Shield, Mail, ArrowRight } from "lucide-react";
import { Button } from "../../components/ui/button";
import CursorGlow from "../../components/CursorGlow";

export default function Pricing() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-950 via-emerald-950 to-gray-950 text-white">
      <CursorGlow />

      {/* Navigation */}
      <nav className="relative z-50 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img src="/ledgeramt-logo.png" alt="LedgerAMT" className="h-14 w-auto" />
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/features" className="text-white/70 hover:text-white transition-colors">Features</Link>
              <Link to="/about" className="text-white/70 hover:text-white transition-colors">About</Link>
              <Link to="/contact" className="text-white/70 hover:text-white transition-colors">Contact</Link>
            </div>
            <div className="flex items-center gap-4">
              <Link to="/login">
                <Button variant="ghost" className="text-white hover:bg-white/10">
                  Sign in
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Access Notice */}
      <section className="flex items-center justify-center min-h-[calc(100vh-80px)] px-6">
        <div className="max-w-lg w-full text-center">
          <div className="w-20 h-20 rounded-full bg-emerald-500/10 border border-emerald-500/20 flex items-center justify-center mx-auto mb-8">
            <Shield className="w-10 h-10 text-emerald-400" />
          </div>

          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Access is by invitation only
          </h1>

          <p className="text-white/60 text-lg mb-8">
            New accounts and subscriptions are managed by administrators.
            Please contact your administrator to request access.
          </p>

          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-8 text-left space-y-3">
            <div className="flex items-start gap-3">
              <Mail className="w-5 h-5 text-emerald-400 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-white">Contact your administrator</p>
                <p className="text-sm text-white/50">Ask your admin to create an account for you and grant access.</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <ArrowRight className="w-5 h-5 text-emerald-400 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-white">Already have an account?</p>
                <p className="text-sm text-white/50">Sign in with the credentials provided by your administrator.</p>
              </div>
            </div>
          </div>

          <Link to="/login">
            <Button className="bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-3 text-base font-semibold">
              Sign In
            </Button>
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-white/10 py-8 px-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <img src="/ledgeramt-logo.png" alt="LedgerAMT" className="h-10 w-auto" />
          <div className="flex items-center gap-6 text-white/40 text-sm">
            <Link to="/features" className="hover:text-white transition-colors">Features</Link>
            <Link to="/about" className="hover:text-white transition-colors">About</Link>
            <Link to="/contact" className="hover:text-white transition-colors">Contact</Link>
          </div>
          <p className="text-white/40 text-sm">© 2026 LedgerAMT. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
